export enum ButtonColors {
    Default     = 'default',
    Accent      = 'accent',
    White       = 'white',
    Gold        = 'gold',
    Transparent = 'transparent',
    Blur        = 'blur',
    Vip         = 'vip',
    Admin       = 'admin'
}